import script from "./MatchdButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatchdButton.vue?vue&type=script&setup=true&lang=ts"

import "./MatchdButton.vue?vue&type=style&index=0&id=64d0fedc&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64d0fedc"]])

export default __exports__